import { Box, Text, Group } from '@mantine/core'

// #1080 共通フッター。リンク一覧は左Navbarの下部に移設したため、ここではコピーライトのみ表示する。
export default function AppFooter({ logoSrc, copyright }) {
  return (
    <Box id="app-footer" component="footer" px="md" py="sm" style={{ background: 'var(--mantine-color-gray-0)' }}>
      <Group justify="center" gap="xs">
        <img src={logoSrc} alt="Bizlink" height={18} />
        <Text fz="xs" c="dimmed">{copyright}</Text>
      </Group>
    </Box>
  )
}
